import { OuiSelectOption } from 'omnium-ui/form-field';

export type SituationMatrimonialeType = 'CELIBATAIRE' | 'MARIE' | 'PACSE' | 'UNIONLIBRE' | 'DIVORCE' | 'VEUF' | 'SEPARE' | 'DECEDE';

export const fullSituationMatrimonialeOptions: OuiSelectOption<SituationMatrimonialeType>[] = [
  { label: 'Célibataire', value: 'CELIBATAIRE' },
  { label: 'Marié(e)', value: 'MARIE' },
  { label: 'Pacsé(e)', value: 'PACSE' },
  { label: 'Union libre', value: 'UNIONLIBRE' },
  { label: 'Divorcé(e)', value: 'DIVORCE' },
  { label: 'Veuf(ve)', value: 'VEUF' },
  { label: 'Séparé(e)', value: 'SEPARE' },
  { label: 'Décédé(e)', value: 'DECEDE' },
];

export const coupleSituationMatrimonialeOptions: OuiSelectOption<SituationMatrimonialeType>[] = [
  { label: 'Marié(e)', value: 'MARIE' },
  { label: 'Pacsé(e)', value: 'PACSE' },
  { label: 'Union libre', value: 'UNIONLIBRE' },
];
